import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'qm-click-to-call',
  templateUrl: './click-to-call.component.html',
  styleUrls: ['./click-to-call.component.scss']
})
export class ClickToCallComponent implements OnChanges {

  @Input()
  public personId: string;

  public zypnoLink: string;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.personId) {
      //// MR-1910
      this.zypnoLink = 'tel:+' + this.getZypnoId(this.personId);
    }
  }

  public getZypnoId = (id: string): string => id?.padStart(7, '0');
}
